document.addEventListener('DOMContentLoaded', () => {
  const videoContainers = document.querySelectorAll('.video-supports');
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  videoContainers.forEach((videoContainer) => {
    const src = videoContainer.getAttribute('data-src');
    const width = videoContainer.getAttribute('data-width');
    const height = videoContainer.getAttribute('data-height');

    const autoplay = videoContainer.getAttribute('data-autoplay') !== 'false';
    const muted = videoContainer.getAttribute('data-muted') !== 'false';
    const loop = videoContainer.getAttribute('data-loop') !== 'false';
    const playsInline = videoContainer.getAttribute('data-playsInline') !== 'false';

    if (isSafari) {
      const imgElement = document.createElement('img');
      imgElement.className = 'video-apple';
      imgElement.src = `${src}.apng`;
      if (width) imgElement.width = width;
      if (height) imgElement.height = height;
      imgElement.alt = '';
      videoContainer.appendChild(imgElement);
    } else {
      const videoElement = document.createElement('video');
      videoElement.className = 'video-all';
      if (width) videoElement.width = width;
      if (height) videoElement.height = height;
      videoElement.autoplay = autoplay;
      videoElement.muted = muted;
      videoElement.loop = loop;
      videoElement.playsInline = playsInline;
      videoElement.preload = 'metadata';

      const sourceElement = document.createElement('source');
      sourceElement.src = `${src}.webm#t=0.05`;
      sourceElement.type = 'video/webm';

      videoElement.appendChild(sourceElement);
      videoContainer.appendChild(videoElement);
    }
  });
});
